import { Injectable } from '@angular/core';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { DriverExaminationWaiveResult } from '../models/requirement/driver-examination-waive-result.model';

@Injectable()
export class RequirementWaiveService extends BaseApiService {
    constructor() {
        super();
    }

    /**
     * Returns the form view model for driver examination waivers
     * @param driverRequirementTypeId
     */
    public getLookups(driverRequirementTypeId: number) {
        return this.get('Driver/Requirement/Waive/ViewModel/' + driverRequirementTypeId);
    }

    public deleteRequirementWaiver(model: DriverExaminationWaiveResult) {
        return this.delete('Driver/Requirement/Waive/' + model.businessTransactionId + '/' + model.driverRequirementTypeId);
    }

    /**
     * Saves waive results from the driver examination manual entry form
     * @param DriverExaminationWaiveResult
     */
    public saveRequirementWaiveResult(model: DriverExaminationWaiveResult) {
        return this.post('Driver/Requirement/Waive/', model);
    }

    /**
     * Saves waive results from the driver examination manual entry form
     * @param DriverExaminationWaiveResult
     */
    public getRequirementWaiveResult(businessTransactionNumber, driverRequirementTypeId) {
        return this.get('Driver/Requirement/Waiver/Status/' + businessTransactionNumber + '/' + driverRequirementTypeId);
    }
}
